import type { Gallery } from '@/src/listings/types';
import { createContext, useContext } from 'react';

export type GalleryContextType = NonNullable<Gallery>;

export const GalleryContext = createContext<GalleryContextType>({} as GalleryContextType);

export const GalleryProvider = ({ children, gallery }: { children: React.ReactNode; gallery: GalleryContextType }) => {
  return <GalleryContext.Provider value={gallery}>{children}</GalleryContext.Provider>;
};

export const useGallery = () => {
  return useContext(GalleryContext);
};
